import { useParams } from 'react-router-dom'

import RewardsTable from '@/components/BuildingDashboard/Rewards/Tabs/RewardsTable/RewardsTable'
import { useDesignVersionToggle } from '@/hooks'

export const GiftCardsLegacyPage = () => {
  const { buildingId } = useParams<{ buildingId?: string }>()

  const { redirect } = useDesignVersionToggle({
    group: 'gift-cards',
    screen: 'GiftCards',
    to: {
      params: { buildingId: buildingId ?? '' },
      path: '/dashboard/building-dashboard/rewards/gift-cards/:buildingId',
    },
    version: 'legacy',
  })

  if (redirect) return redirect

  return <RewardsTable />
}
